<template>
  <div class="index">
    <el-row  style="padding-top: 64px;display:flex;justify-content:center">
      <el-col style="max-width:400px;display:flex;justify-content:center">
      <div>
        <p class="title-text">发薪类型</p>
          <el-select  class='type' @change="handleChange" clearable v-model="$store.state.stepOne.value" placeholder="请选择" style="width: 100%">
            <el-option v-for="(item,i) in options" :key="i" :label="item.text" :value="item.text"></el-option>
          </el-select>
          <p class="title-text">发薪时间</p>
          <el-date-picker style="width: 100%" v-model="$store.state.stepOne.value2" @change="changaTime" type="month" placeholder="选择月"></el-date-picker>
          <p >
            <Upload ref="upload" style="display: inline-block; width: 100%" :headers="{
                Authorization: uploadToken,
              }" :multiple="false" :show-upload-list="true" :on-success="handleSuccess" :on-error="onerror" :before-upload="handleBefore" :data="uploadData" :on-remove="handleRemove" :default-file-list="$store.state.stepOne.uploadList" :action="`${$http.defaults.baseURL}/salary-service/customer/import`">
              <el-button style="margin-top: 30px" class="login-btn" :loading="showUpLoadBtn" type="info" v-if="$store.state.stepOne.uploadList.length == 0 ? true : false" icon="ios-cloud-upload-outline">
                <div class="btnbox">
                  <img src="@/assets/uploadBtn.png" alt="" style="width: 18px" />
                  <span style="margin-left: 8px; line-height: 18px">导入工资表</span>
                </div>
              </el-button>
            </Upload>
          </p>
          <p class="upload-text" >
            上传日常所用的Excel工资表必须包含员工邮箱或手机号码
          </p>
          <p style="text-align: center; width: 100%;color: rgb(131, 143, 153);">
            <a href="./static/template.xlsx" download="悦享工资表模板.xlsx" target="_self" style="color: #3bc492; text-decoration: none">点击下载模板</a>
            （<span style="color: red">*</span>可填入自己电话邮箱试用）
          </p>
         <div class="flex-center">
            <el-button class="next-btn" type="success"  @click="next1">下一步</el-button>
         </div>
      </div>
      </el-col>
    </el-row>
    <Loading v-if="loadingFlg"></Loading>
  </div>
</template>

<script>
import { constants } from 'crypto';
import {
  Button,
  Carousel,
  CarouselItem,
  Upload,
} from 'iview';
import Cookie from 'js-cookie';
import moment from 'moment';
import { userInfo } from 'os';

import { getTypeList } from '@/api/setUp.js';
import Loading from '@/components/loading';

export default {
  name: 'setp1',
  components: {
    Upload,
    Button,
    Carousel,
    CarouselItem,
    Loading,
  },
  data () {
    return {
      loadingFlg: false,
      uploadData: {},
      uploadToken: 'Bearer ' + window.sessionStorage.getItem('token'),
      routes: [],
      initSetting: false,
      top: [],
      isCollapse: false,
      // value1: 0,
      options: [
        
      ],
      fileList: [],
      showUpLoadBtn: false,
    }
  },
  methods: {
     next1(){
       this.$emit('next1');
     },
    async getTypeLists(){
      let {data} =await getTypeList()
      this.options=data;
    },
    changaTime (val) {
      console.log(val)
      this.$store.commit('getUploadList', [])
    },
    handleChange (val) {
      this.$store.commit('getUploadList', [])
      console.log(val)
      this.$store.commit('getsalaryType', val)
    },
    handleRemove (file, fileList) {
      console.log(fileList)
      this.fileList = fileList
      this.$store.commit('getUploadList', [])
    },

    // 第一步导入
    handleSuccess (response, file, fileList) {
      if (response.code == 200) {
        this.$message({
          type: 'success',
          message: '导入完成',
        })
        this.fileList = fileList
        this.showUpLoadBtn = false
        this.loadingFlg = false
        // 第二步存储后端解析的数据
        // $store.state.responeList
        console.log('第一步导入之后返回的数据', response.data)
        this.$store.commit('getList', response.data)

        // 将第一步数据存入query中
        let month = new Date(this.$store.state.stepOne.value2).getMonth() + 1
        let year = new Date(this.$store.state.stepOne.value2).getFullYear()
        let salaryType = this.$store.state.stepOne.value
        this.$store.state.responeList.query.month = month
        this.$store.state.responeList.query.year = year
        this.$store.state.responeList.query.salaryType = salaryType
        this.$store.commit('getUploadList', fileList)
      } else {
        this.$message({
          type: 'warning',
          message: response.msg || '网络异常',
        })
        this.showUpLoadBtn = false
        this.loadingFlg = false
        this.$store.commit('getUploadList', [])
      }
    },

    // handleSuccess(response, file, fileList) {
    //   console.log('success', response)
    //   if (response.code == 200) {
    //     this.$message({
    //       type: 'success',
    //       message: '导入完成',
    //     })
    //     this.fileList = fileList
    //     this.showUpLoadBtn = false
    //     this.$store.commit('getList', response.data)
    //     this.$store.commit('getUploadList', fileList)
    //     this.$store.commit('getSetpThreeTotal', response.data.data.length)
    //     // this.$store.commit('getStepThreeData', response.data.data)
    //     this.$store.commit('getStepThreeData', response.data.data)
    //     this.$store.commit(
    //       'getSetpThreeHtml',
    //       JSON.parse(response.data.data[0].c)
    //     )
    //     // this.active = 2
    //     this.btnLoading = false
    //   } else {
    //     this.$message({
    //       type: 'warning',
    //       message: response.msg || '网络异常',
    //     })
    //     this.showUpLoadBtn = false
    //     this.$store.commit('getUploadList', [])
    //   }
    // },
    onerror (err) {
      console.log(err)
      this.$notify({
        title: '失败',
        message: '网络异常，请稍后重试',
        type: 'warning',
      })
      // window.location.href = './'
      // this.$message({
      //   type: 'error',
      //   message: 'Excel文件内容解析失败，请重检查文件内容并重试！',
      // })
      // this.$message({
      //   type: 'error',
      //   message: '该账户已被封禁  ',
      // })
      this.showUpLoadBtn = false
      this.loadingFlg = false
    },
    handleBefore (file) {
      if (
        this.$store.state.stepOne.value2 &&
        this.$store.state.stepOne.salaryType
      ) {
        this.loadingFlg = true
        return file
      } else {
        this.$message({
          type: 'info',
          message: '请先选择发薪类型和发薪时间',
        })
        return false
      }
    },
  },
  mounted () {
    this.getTypeLists();
    // if(!window.localStorage.getItem('isIntorShow')){
    //   window.localStorage.setItem('isIntorShow',true)
    //   this.isIntorShow=true
    //    console.log(this.isIntorShow)
    // }else{
    //   window.localStorage.setItem('isIntorShow',false)
    //   this.isIntorShow=false
    //   console.log(this.isIntorSho
    // }
  },
  watch: {
    getvalue () { },
  },
  computed: {
    getvalue () {
      if (
        this.$store.state.stepOne.value2 &&
        this.$store.state.stepOne.salaryType
      ) {
        let month = new Date(this.$store.state.stepOne.value2).getMonth() + 1
        this.uploadData.year = new Date(
          this.$store.state.stepOne.value2
        ).getFullYear()
        this.uploadData.month = month > 9 ? month : '0' + month
        this.uploadData.salaryType = this.$store.state.stepOne.salaryType
        console.log(this.uploadData)
      }
      return this.$store.state.stepOne.value &&
        this.$store.state.stepOne.value2 &&
        this.$store.state.responeList.length
        ? true
        : false
    },
  },
}
</script>

<style lang="less" scoped>
.login-btn {
  width: 100%;
  height: 48px;
  background: #3bc492;
  border-radius: 32px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 18px;
    height: 18px;
  }
  &:hover {
    background: rgba(59, 196, 146, 0.7);
    border-color: rgba(59, 196, 146, 0.7);
  }
}

.index {
  height:calc(100vh - 134px);
    background:#fff;
    margin:10px 10px 0;
    overflow: hidden;
    border-radius: 8px;
  .title-text {
    font-size: 16px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #838F99;
    line-height: 30px;
    // height: 50px;
  }

  .el-select {
    width: 384px;
  }
  .el-select.type{
    margin-bottom:25px;
  }
  .el-date-editor {
    width: 384px;
  }
}

.btnbox {
  display: flex;
  align-items: center;
  justify-content: center;
}
/deep/.ivu-upload-list-remove {
  opacity: 1;
}
.upload-text{
  width: 100%; 
  text-align: center; 
  line-height: 32px;
  color:rgb(131, 143, 153);
}
.flex-center{
  margin-top:30px;
  display:flex;
  justify-content: center;
}
.next-btn {
  width: 200px !important;
}
</style>
